/* CRTD Cart — AJAX add-to-bag, drawer re-render, quantity stepper, counter sync.
   Spec §5.1. */
(function () {
  'use strict';

  var doc = document;

  // ---------- Utility: format money (cents → "AUD $x.xx") ----------
  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ---------- Header bag counter ----------
  function updateCounter(count) {
    var span = doc.querySelector('[data-crtd-bag-count]');
    if (span) span.textContent = count;
    // Also update the parent link text to keep "Bag (n)" pattern
    var link = doc.querySelector('[data-crtd-bag]');
    if (link) link.setAttribute('aria-label', 'Bag, ' + count + ' item' + (count === 1 ? '' : 's'));
  }

  // ---------- Build line-item HTML from cart JSON ----------
  function buildLineItemsHTML(cart) {
    if (!cart.items || cart.items.length === 0) {
      var allUrl = (window.__crtdRoutes && window.__crtdRoutes.allProducts) ? window.__crtdRoutes.allProducts : '/collections/all';
      return '<div class="crtd-cart-empty">' +
        '<p class="crtd-cart-empty-msg">Your bag is empty.</p>' +
        '<a href="' + allUrl + '" class="crtd-cart-empty-cta">Explore the collection</a>' +
        '</div>';
    }

    var html = '<ul class="crtd-cart-list" aria-label="Items in your bag">';
    cart.items.forEach(function (item, idx) {
      var lineNum = idx + 1;
      var thumbHTML;
      if (item.image) {
        thumbHTML = '<img src="' + item.image + '" alt="' + escapeHTML(item.title) + '" class="crtd-cart-thumb-img" loading="lazy">';
      } else {
        thumbHTML = '<div class="crtd-cart-thumb-ph" aria-hidden="true"></div>';
      }

      var variantHTML = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantHTML = '<p class="crtd-cart-item-variant">' + escapeHTML(item.variant_title) + '</p>';
      }

      html += '<li class="crtd-cart-item" data-crtd-line="' + lineNum + '">' +
        '<div class="crtd-cart-thumb">' + thumbHTML + '</div>' +
        '<div class="crtd-cart-item-body">' +
          '<p class="crtd-cart-item-name">' + escapeHTML(item.product_title) + '</p>' +
          variantHTML +
          '<div class="crtd-cart-item-foot">' +
            '<div class="crtd-cart-stepper" data-crtd-stepper>' +
              '<button type="button" class="crtd-cart-step-btn" data-crtd-step="-1" aria-label="Decrease quantity">−</button>' +
              '<span class="crtd-cart-step-qty" data-crtd-qty>' + item.quantity + '</span>' +
              '<button type="button" class="crtd-cart-step-btn" data-crtd-step="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span class="crtd-cart-item-price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="crtd-cart-remove" data-crtd-remove aria-label="Remove ' + escapeHTML(item.title) + ' from bag">Remove</button>' +
        '</div>' +
        '</li>';
    });

    html += '</ul>';

    // Subtotal row
    html += '<div class="crtd-cart-subtotal">' +
      '<span class="crtd-cart-subtotal-l">Subtotal</span>' +
      '<span class="crtd-cart-subtotal-v" data-crtd-subtotal>' + formatMoney(cart.total_price) + '</span>' +
      '</div>';

    return html;
  }

  function escapeHTML(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ---------- Re-render drawer body from cart JSON ----------
  function renderDrawer(cart) {
    var body = doc.querySelector('[data-crtd-cart-body]');
    var footer = doc.querySelector('[data-crtd-cart-footer]');
    if (!body) return;

    body.innerHTML = buildLineItemsHTML(cart);

    if (footer) {
      footer.style.display = (cart.item_count > 0) ? '' : 'none';
    }

    updateCounter(cart.item_count);
  }

  // ---------- Fetch fresh cart state ----------
  function fetchCart(callback) {
    fetch('/cart.js', {
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (callback) callback(cart); })
      .catch(function (err) { console.error('[CRTD cart] fetch /cart.js failed:', err); });
  }

  // ---------- Open the cart drawer ----------
  function openCart() {
    // Dispatch a click on the first [data-crtd-open="cart"] element so crtd-chrome.js
    // runs its full openPanel() logic (focus trap, inert, backdrop, aria).
    var trigger = doc.querySelector('[data-crtd-open="cart"]');
    if (trigger) {
      trigger.click();
    }
  }

  // ---------- Cart change (stepper / remove) ----------
  function changeCartLine(lineIndex, newQty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: lineIndex, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderDrawer(cart); })
      .catch(function (err) { console.error('[CRTD cart] /cart/change.js failed:', err); });
  }

  // ---------- Cart drawer event delegation (stepper + remove) ----------
  doc.addEventListener('click', function (e) {
    // Stepper step button
    var stepBtn = e.target.closest('[data-crtd-step]');
    if (stepBtn) {
      var item = stepBtn.closest('[data-crtd-line]');
      if (!item) return;
      var lineIndex = parseInt(item.getAttribute('data-crtd-line'), 10);
      var qtyEl = item.querySelector('[data-crtd-qty]');
      var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var delta = parseInt(stepBtn.getAttribute('data-crtd-step'), 10);
      var newQty = Math.max(0, currentQty + delta);
      changeCartLine(lineIndex, newQty);
      return;
    }

    // Remove button
    var removeBtn = e.target.closest('[data-crtd-remove]');
    if (removeBtn) {
      var removeItem = removeBtn.closest('[data-crtd-line]');
      if (!removeItem) return;
      var removeLine = parseInt(removeItem.getAttribute('data-crtd-line'), 10);
      changeCartLine(removeLine, 0);
      return;
    }
  });

  // ---------- PDP form intercept (AJAX add-to-bag) ----------
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-crtd-pform]');
    if (!form) return;

    e.preventDefault();

    var addBtn = form.querySelector('[data-crtd-add-btn]');
    var errorEl = form.querySelector('.crtd-cart-error');
    var originalText = addBtn ? addBtn.textContent : '';

    // Loading state
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = 'Adding\u2026';
    }
    if (errorEl) errorEl.removeAttribute('data-visible');

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (body) { throw new Error(body.description || body.message || 'Unable to add to bag.'); });
        }
        return r.json();
      })
      .then(function () {
        // Restore button
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = originalText;
        }
        // Fetch fresh cart, re-render drawer, open it
        fetchCart(function (cart) {
          renderDrawer(cart);
          openCart();
        });
      })
      .catch(function (err) {
        // Restore button + surface error
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = originalText;
        }
        if (errorEl) {
          errorEl.textContent = err.message;
          errorEl.setAttribute('data-visible', '');
        } else {
          // Inject an error element if one doesn't exist yet
          var inserted = doc.createElement('p');
          inserted.className = 'crtd-cart-error';
          inserted.setAttribute('data-visible', '');
          inserted.textContent = err.message;
          var ctas = form.querySelector('.crtd-pdp-ctas');
          if (ctas) ctas.insertAdjacentElement('afterend', inserted);
          else form.appendChild(inserted);
        }
        console.error('[CRTD cart] /cart/add.js failed:', err);
      });
  });

  // ---------- Sync counter on page load ----------
  fetchCart(function (cart) {
    updateCounter(cart.item_count);
  });

})();
